import api from './api-config';

// Authentication API functions
export const login = async (email, password) => {
    try {
        // Convert to FormData format for OAuth2 compatibility
        const formData = new URLSearchParams();
        formData.append('username', email);
        formData.append('password', password);

        const response = await api.post('/auth/login', formData, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        });

        // Store token in localStorage
        if (response.data.access_token) {
            localStorage.setItem('token', response.data.access_token);
            localStorage.setItem('user', JSON.stringify({
                id: response.data.user_id,
                email: response.data.email,
                username: response.data.username,
                organizations: response.data.organizations
            }));

            // Set default Authorization header for future requests
            api.defaults.headers.common['Authorization'] = `Bearer ${response.data.access_token}`;
        }

        return response.data;
    } catch (error) {
        console.error('Login error:', error);
        throw error;
    }
};

export const register = async (userData) => {
    try {
        const response = await api.post('/auth/register', userData);

        // Store token in localStorage
        if (response.data.access_token) {
            localStorage.setItem('token', response.data.access_token);
            localStorage.setItem('user', JSON.stringify({
                id: response.data.user_id,
                email: response.data.email,
                username: response.data.username,
                organizations: response.data.organizations
            }));

            // Set default Authorization header for future requests
            api.defaults.headers.common['Authorization'] = `Bearer ${response.data.access_token}`;
        }

        return response.data;
    } catch (error) {
        console.error('Registration error:', error);
        throw error;
    }
};

export const googleLogin = async (token) => {
    try {
        const response = await api.post('/auth/google', { token });

        // Store token in localStorage
        if (response.data.access_token) {
            localStorage.setItem('token', response.data.access_token);
            localStorage.setItem('user', JSON.stringify({
                id: response.data.user_id,
                email: response.data.email,
                username: response.data.username,
                organizations: response.data.organizations
            }));

            // Set default Authorization header for future requests
            api.defaults.headers.common['Authorization'] = `Bearer ${response.data.access_token}`;
        }

        return response.data;
    } catch (error) {
        console.error('Google login error:', error);
        throw error;
    }
};

export const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('currentOrganization');
    localStorage.removeItem('selectedOrganizationId');

    // Remove Authorization header
    delete api.defaults.headers.common['Authorization'];
};

export const getCurrentUser = async () => {
    try {
        const response = await api.get('/auth/me');
        return response.data;
    } catch (error) {
        console.error('Error fetching current user:', error);
        throw error;
    }
};


export const joinDemoOrganization = async () => {
    const response = await api.post('/auth/join-demo');
    return response.data;
};

// Initialize auth state from localStorage
export const initAuth = () => {
    const token = localStorage.getItem('token');
    if (token) {
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return true;
    }
    return false;
};
